import styled from "styled-components";
import { FullHeightGrid } from "./FullHeightGrid";
export const RowGrid = styled(FullHeightGrid) `
  grid-template-rows: ${props => props.$template_rows};
  grid-template-columns: 1fr;
  grid-auto-rows: ${props => props.$auto_rows || "max-content"};
`;
